import ForgetPasswordForm from "../../components/User/ForgetPassword";

const ForgetPassword = () => {
    return(
        <ForgetPasswordForm />
    )
}

export default ForgetPassword;